import type { NoticePriority, NoticeCategory } from '../../../types/notice.types';

/** 우선순위별 스타일 맵 */
export const priorityStyles: Record<NoticePriority, {
  color: string;
  bgColor: string;
  gradient: string;
  borderColor: string;
  label: string;
  dotColor: string;
}> = {
  urgent: {
    color: '#dc2626',
    bgColor: '#fef2f2',
    gradient: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
    borderColor: '#ef4444',
    label: '긴급',
    dotColor: '#ef4444',
  },
  important: {
    color: '#d97706',
    bgColor: '#fffbeb',
    gradient: 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)',
    borderColor: '#f59e0b',
    label: '중요',
    dotColor: '#f59e0b',
  },
  normal: {
    color: '#2563eb',
    bgColor: '#eff6ff',
    gradient: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
    borderColor: '#3b82f6',
    label: '일반',
    dotColor: '#3b82f6',
  },
};

/** 카테고리별 스타일 맵 */
export const categoryStyles: Record<NoticeCategory, {
  color: string;
  bgColor: string;
  icon: string;
}> = {
  '서비스 안내': { color: '#2563eb', bgColor: '#eff6ff', icon: '📋' },
  '시세 변동': { color: '#059669', bgColor: '#ecfdf5', icon: '📈' },
  '이벤트': { color: '#7c3aed', bgColor: '#f5f3ff', icon: '🎉' },
  '점검 안내': { color: '#dc2626', bgColor: '#fef2f2', icon: '🔧' },
};
